<div class="container">
  <app-sub-header></app-sub-header>
  <mat-table
    [dataSource]="dataSource"
    id="matTable"
  >

    <ng-container matColumnDef="symbol">
      <mat-header-cell *matHeaderCellDef> Symbol </mat-header-cell>
      <mat-cell
        class="cell-symbol"
        *matCellDef="let element"
      >
        {{element.symbol
          .split('"').join(' ')
          .split('?').join(' ')
          .split('(').join(' ')
          .split(')').join(' ')}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="updated">
      <mat-header-cell *matHeaderCellDef> Reported (NY time) </mat-header-cell>
      <mat-cell
        class="cell"
        *matCellDef="let element"
        [innerHtml]="dtService.concatDate(element.ts)"
      > </mat-cell>
    </ng-container>

    <ng-container matColumnDef="transactionDate">
      <mat-header-cell *matHeaderCellDef> Purchase Date </mat-header-cell>
      <mat-cell
        class="cell"
        *matCellDef="let element"
        [innerHtml]="dtService.monthAndDay(element.transactionDate)"
      > </mat-cell>
    </ng-container>
    <ng-container matColumnDef="transactionValue">
      <mat-header-cell *matHeaderCellDef> Total value ($) </mat-header-cell>
      <mat-cell
        class="cell-symbol"
        *matCellDef="let element"
      > {{element.transactionValue | comma }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="transactionPricePerShare">
      <mat-header-cell *matHeaderCellDef> Avg. Price </mat-header-cell>
      <mat-cell
        class="cell"
        *matCellDef="let element"
      > {{element.transactionPricePerShare | comma}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="transactionShares">
      <mat-header-cell *matHeaderCellDef> Number of shares </mat-header-cell>
      <mat-cell
        class="cell"
        *matCellDef="let element"
      > {{element.transactionShares | comma }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="isTenPercentOwner">
      <mat-header-cell *matHeaderCellDef> 10% Owner </mat-header-cell>
      <mat-cell
        class="cell"
        *matCellDef="let element"
      > {{element.isTenPercentOwner | role}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="company">
      <mat-header-cell *matHeaderCellDef> Company </mat-header-cell>
      <mat-cell
        class="cell"
        *matCellDef="let element"
      > {{element.company}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns;"
      matRipple
      class="element-row"
      [cdkDetailRow]="row"
      [cdkDetailRowTpl]="tpl"
      (toggleChange)="onToggleChange($event)"
      (click)="rowClicked($event, row)"
    >
    </tr>
  </mat-table>
</div>
<ng-template #tpl>
  <div
    class="detail-row"
    [@detailExpand]
  >
    <div
      class="top-components"
      fxLayout
      fxLayout.xs="column"
      fxLayoutAlign="center"
      fxLayoutGap="6px"
      fxLayoutGap.xs="0"
    >
      <app-quote fxFlex="50%"></app-quote>
      <!-- <app-chart fxFlex="50%"></app-chart> -->
      <app-details fxFlex="50%"></app-details>
    </div>
    <div
      fxLayout
      fxLayout.xs="column"
      fxLayoutAlign="center"
      fxLayoutGap="6px"
      fxLayoutGap.xs="0"
    >
      <app-news fxFlex="50%"></app-news>
      <app-cik fxFlex="50%"></app-cik>

    </div>

  </div>
</ng-template>
